"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var states_1 = require("../../../common/constants/states");
var payment_methods_1 = require("../../../common/constants/payment_methods");
var months_and_years_1 = require("../../../common/constants/months_and_years");
var BillingGateway_1 = require("../../../classes/billing/BillingGateway");
var Teller_1 = require("../../../../DriveScout/Billing/Teller");
var Product_1 = require("../../../classes/Product");
var Coupon_1 = require("../../../classes/Coupon");
var Student_1 = require("../../../classes/Student");
var Address_1 = require("../../../classes/Address");
var CreditCard_1 = require("../../../classes/CreditCard");
var Cashier_1 = require("../../../classes/Cashier");
var PaymentRequest_1 = require("../../../common/payments/PaymentRequest");
var dsOrderFormController = /** @class */ (function () {
    function dsOrderFormController($scope, $location, UsersModel, FlashService, CreateOrderService, SchoolsModel, VueStoreFactory) {
        var _this = this;
        /**
         * The PayPal approval's key, held from its create until PayPalCard's
         * capture ends. A card order's key is the host page's: it sends that order.
         */
        this.paypalApproval = new PaymentRequest_1.PaymentRequest();
        this.loading = true;
        this.submitting = false;
        this.inDollars = Teller_1.inDollars.bind(this);
        this.coupons = [];
        this.CreateOrderService = CreateOrderService;
        this.SchoolsModel = SchoolsModel;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.VueStoreFactory = VueStoreFactory;
        this.billingAddressDoesNotAlreadyExist = false;
        this.gateway = "none";
        this.gateway_config = {};
        this.returnUrl = $location.absUrl();
        this.gatewayOrderId = "";
        this.surchargeAmountBilled = 0;
        this.handleAuthorizeCard = this.handleAuthorizeCard.bind(this);
        this.handleAuthorizeError = this.handleAuthorizeError.bind(this);
        this.handleCompletedConfirmationToken =
            this.handleCompletedConfirmationToken.bind(this);
        this.setStudentCart = this.setStudentCart.bind(this);
        this.tokenizationSupported = this.tokenizationSupported.bind(this);
        this.handlePaypalCardTokenCreated =
            this.handlePaypalCardTokenCreated.bind(this);
        this.createPaypalOrder = this.createPaypalOrder.bind(this);
        this.showUseExistingPaymentMethodUI = false;
        this.billingAddress = {
            street: "",
            city: "",
            state: "",
            zip: "",
            lat: 0,
            lng: 0,
        };
        /**
         * The coupon the admin selects to add to the order.
         */
        this.selectedCoupon = {};
        //////////////////////////////////
        /** @type Cashier */
        this.$cashier = this.CreateOrderService.cashier();
        $scope.$watch(function () { return _this.$cashier.$order.$student; }, function (newVal) {
            if (!_this.$cashier.$order.$student) {
                return;
            }
            if (_this.gateway === "stripe") {
                _this.returnUrl =
                    $location.absUrl() +
                        "?student_id=" +
                        _this.$cashier.order().student().id();
            }
        });
        var policies = this.$cashier.policies();
        var billingPolicy = policies.getPolicyByName("billing");
        if (billingPolicy.metaExistsByKey("billing_gateway")) {
            this.gateway = billingPolicy.getMetaValueByKey("billing_gateway");
            this.gateway_config = (0, BillingGateway_1.createBillingGatewayFromPolicies)(policies).config();
        }
        if (this.gateway === "stripe") {
            var student_id = 0;
            this.stripeElementOptions = {
                currency: "usd",
                amount: undefined,
            };
        }
        if (this.gateway === "paypal") {
            this.gatewayOrderId = ""; // order.gateway_order_id
        }
        // set surcharge data
        this.surchargeBilledSeparately = this.$cashier.surchargeBilledSeparately();
        this.surchargeAmount = this.$cashier.surchargePercentage();
        this.surchargeDetail = this.$cashier.surchargeDetail();
        // set payment methods
        this.payment_methods = [].concat(payment_methods_1.PaymentMethods);
        if (this.gateway === "none") {
            this.payment_methods = this.payment_methods.filter(function (method) {
                return method.value !== "card";
            });
            this.$cashier.order().payments()[0].$payment_method = "other";
        }
        this.months = months_and_years_1.Months;
        this.years = months_and_years_1.Years;
        this.states = states_1.States;
        this.loading = false;
    }
    dsOrderFormController.prototype.tokenizationSupported = function () {
        if (this.gateway === "authorize" &&
            this.gateway_config.authorize_api_client_key) {
            return true;
        }
        if (this.gateway === "stripe") {
            return true;
        }
        if (this.gateway === "square") {
            return true;
        }
        if (this.gateway === "paypal") {
            return true;
        }
        return false;
    };
    dsOrderFormController.prototype.createPaypalOrder = function (data, actions) {
        return __awaiter(this, void 0, void 0, function () {
            var order, response, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.$cashier.order().$payments = this.$cashier
                            .order()
                            .payments()
                            .map(function (payment) {
                            if (payment.paymentMethod() === "card") {
                                payment.creditCard().tokenize(data);
                                payment.$card.$save_payment_method = _this.$cashier
                                    .order()
                                    .payments()[0].$card.$save_payment_method;
                            }
                            return payment;
                        });
                        order = (0, Cashier_1.cashierOrderRequestTransformer)(this.$cashier);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.VueStoreFactory.dispatch("CREATE_PAYPAL_ORDER", this.paypalApproval.bodyFor((0, PaymentRequest_1.orderWithoutOneTimeTokens)(order), function (requestId) { return (__assign(__assign({}, order), { request_id: requestId })); }))];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.paypalApproval.settled(PaymentRequest_1.PaymentOutcome.failed(error_1));
                        throw error_1;
                    case 4: 
                    // Return both IDs - PayPal order ID for the SDK, DriveScout order ID for capture
                    return [2 /*return*/, {
                            paypal_order_id: response.order_id,
                            drivescout_order_id: response.order.id,
                        }];
                }
            });
        });
    };
    dsOrderFormController.prototype.handlePaypalCardTokenCreated = function (token) {
        // For PayPal, the order is already created and payment is already captured
        // by the PayPal component (createPaypalOrder + CAPTURE_PAYPAL_ORDER).
        // We should NOT call submit() as that would create a duplicate order.
        // Instead, notify the parent that the PayPal order is complete.
        this.paypalApproval.settled(PaymentRequest_1.PaymentOutcome.succeeded());
        if (this.onPaypalOrderComplete) {
            this.onPaypalOrderComplete({
                orderId: token.drivescout_order_id,
                studentId: this.$cashier.order().student().id(),
            });
        }
    };
    dsOrderFormController.prototype.buttonText = function () {
        var msg = "Submit Order";
        if (this.$cashier.order().payments()[0].amount()) {
            msg += " and Payment for " + this.$cashier.amountPaidToday();
        }
        return msg;
    };
    dsOrderFormController.prototype.toggleUseExistingPaymentMethod = function () {
        this.showUseExistingPaymentMethodUI = !this.showUseExistingPaymentMethodUI;
        if (this.showUseExistingPaymentMethodUI === true) {
            delete this.$cashier.$order.$payments[0].$card.$payment_method_id;
            delete this.stripeElementOptions.amount;
        }
    };
    dsOrderFormController.prototype.proceedToPayment = function (amount) {
        delete this.$cashier.$order.$payments[0].$card.$payment_method_id;
        this.showUseExistingPaymentMethodUI = false;
        this.$cashier.$order.$payments[0].$amount = amount;
        this.stripeElementOptions.amount = amount;
    };
    dsOrderFormController.prototype.setStudentCart = function (billingAddressFromComponent) {
        var payload = {
            products: this.$cashier
                .order()
                .products()
                .map(function (product) {
                return { id: product.id() };
            }),
            payment_amount: this.$cashier.$order.$payments[0].$amount,
            payment_method: this.$cashier.$order.$payments[0].$payment_method,
        };
        if (this.$cashier.order().coupon() != null) {
            payload.coupon = {
                id: this.$cashier.order().coupon().id(),
            };
        }
        // Use billing address from component if provided (PayPal), otherwise use cashier
        if (billingAddressFromComponent && billingAddressFromComponent.street) {
            payload.billing_address = {
                street: billingAddressFromComponent.street,
                city: billingAddressFromComponent.city,
                state: billingAddressFromComponent.state,
                zip: billingAddressFromComponent.zip,
            };
        }
        else if (this.$cashier.order().payments()[0].creditCard().billingAddress().street()) {
            payload.billing_address = {
                street: this.$cashier
                    .order()
                    .payments()[0]
                    .creditCard()
                    .billingAddress()
                    .street(),
                city: this.$cashier
                    .order()
                    .payments()[0]
                    .creditCard()
                    .billingAddress()
                    .city(),
                state: this.$cashier
                    .order()
                    .payments()[0]
                    .creditCard()
                    .billingAddress()
                    .region(),
                zip: this.$cashier
                    .order()
                    .payments()[0]
                    .creditCard()
                    .billingAddress()
                    .postalCode(),
            };
        }
        // If billing address was passed from a component (e.g., PayPal), also update local cashier
        if (billingAddressFromComponent && billingAddressFromComponent.street) {
            var address = new Address_1.Address(0, "", billingAddressFromComponent.street, billingAddressFromComponent.city, billingAddressFromComponent.state, billingAddressFromComponent.zip, 0, 0);
            this.$cashier
                .order()
                .payments()[0]
                .creditCard()
                .setBillingAddress(address);
        }
        return this.UsersModel.setStudentCart(this.$cashier.order().student().id(), payload)
            .then(function (response) {
            return response;
        })
            .catch(function (Error) {
            console.error(Error);
        });
    };
    dsOrderFormController.prototype.handleCompletedConfirmationToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var cart, products, coupon, student, billing_address, payment_amount, payment_method, $products, $student, $coupon, address;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.UsersModel.getStudentCart(this.$cashier.order().student().id())];
                    case 1:
                        cart = (_a.sent()).cart;
                        products = cart.products, coupon = cart.coupon, student = cart.student, billing_address = cart.billing_address, payment_amount = cart.payment_amount, payment_method = cart.payment_method;
                        $products = products.map(function (p) { return new Product_1.Product(p); });
                        $student = new Student_1.Student(student);
                        this.$cashier.order().setProducts($products);
                        this.$cashier.order().setStudent($student);
                        if (coupon) {
                            $coupon = new Coupon_1.Coupon(coupon);
                            this.$cashier.order().setCoupon($coupon);
                        }
                        if (billing_address) {
                            address = new Address_1.Address(0, "", billing_address.street, billing_address.city, billing_address.state, billing_address.zip, 0, 0);
                            this.$cashier.$order.$payments[0].$card.$billing_address = address;
                        }
                        this.$cashier.$order.$payments[0].$amount = payment_amount;
                        this.$cashier.$order.$payments[0].$payment_method = payment_method;
                        // set token data on order
                        this.$cashier.order().$payments = this.$cashier
                            .order()
                            .payments()
                            .map(function (payment) {
                            if (payment.paymentMethod() === "card") {
                                if (_this.gateway === "stripe" || _this.gateway === "square") {
                                    payment.creditCard().tokenize(token.token);
                                    payment.$card.$save_payment_method = token.save_payment_method;
                                }
                                else {
                                    payment.creditCard().tokenize(token);
                                }
                                payment.$card.$save_payment_method = _this.$cashier
                                    .order()
                                    .payments()[0].$card.$save_payment_method;
                            }
                            return payment;
                        });
                        this.submit(this.$cashier.order());
                        return [2 /*return*/, true];
                }
            });
        });
    };
    dsOrderFormController.prototype.handleAuthorizeCard = function (tokenData) {
        var _this = this;
        var valid = this.$cashier.order().products().length === 0 ||
            !this.$cashier.order().student(); // || this.$cashier.order().submitted === true;
        if (!valid) {
            // fail
        }
        if (!this.gateway_config.authorize_api_client_key) {
            var card = new CreditCard_1.CreditCard(tokenData);
            if (tokenData.billing_address) {
                var address = new Address_1.Address(0, "", tokenData.billing_address.street, tokenData.billing_address.city, tokenData.billing_address.state, tokenData.billing_address.zip, 0, 0);
                card.setBillingAddress(address);
            }
            card.$save_payment_method = tokenData.save_payment_method;
            this.$cashier.order().payments()[0].$card = card;
        }
        else {
            // set token data on order
            this.$cashier.order().$payments = this.$cashier
                .order()
                .payments()
                .map(function (payment) {
                if (payment.paymentMethod() === "card") {
                    payment.creditCard().tokenize({ opaqueData: tokenData });
                    payment.$card.$save_payment_method = _this.$cashier
                        .order()
                        .payments()[0].$card.$save_payment_method;
                }
                return payment;
            });
        }
        this.submit(this.$cashier.order());
    };
    dsOrderFormController.prototype.handleAuthorizeError = function (errorData) {
        console.error("Authorize.Net tokenization failed:", errorData);
        // Show error message to user
        this.FlashService.setMessage({
            type: "error",
            message: "Payment processing failed: " +
                (errorData.messages ? errorData.messages.join(", ") : "Unknown error"),
        });
        // Re-enable the submit button
        this.$cashier.order().submitted = false;
    };
    dsOrderFormController.prototype.removeCoupon = function () {
        this.$cashier.removeCoupon();
        this.$cashier.order().payments()[0].setAmount(this.$cashier.totalDue());
        this.$cashier.calculateTotal();
    };
    dsOrderFormController.prototype.removeProductFromOrder = function (index, product) {
        // @todo bug fix, send index into remove product
        this.$cashier.removeProduct(product);
        var oldPaymentAmount = this.$cashier.order().payments()[0].amount();
        var newTotalWithoutSurcharge = this.$cashier.totalDue();
        if (oldPaymentAmount > newTotalWithoutSurcharge) {
            this.$cashier.order().payments()[0].setAmount(newTotalWithoutSurcharge);
        }
        this.$cashier.calculateTotal();
    };
    /**
     * Set the billing address of the given payment at the index provided.
     */
    dsOrderFormController.prototype.addBillingAddress = function (index, address) {
        this.billingAddress = {
            street: address.street(),
            state: address.region(),
            city: address.city(),
            zip: address.postalCode(),
        };
        this.$cashier.addBillingAddress(index, address);
        this.$cashier.calculateTotal();
    };
    dsOrderFormController.prototype.selectPaymentMethod = function (paymentMethodID, paymentIndex) {
        this.$cashier.setCustomerPaymentMethod(paymentMethodID, paymentIndex);
    };
    return dsOrderFormController;
}());
dsOrderFormController.$inject = [
    "$scope",
    "$location",
    "UsersModel",
    "FlashService",
    "CreateOrderService",
    "SchoolsModel",
    "VueStoreFactory",
];
exports.default = dsOrderFormController;
